import moment from "moment";
import { useSetRecoilState } from "recoil";
import {
  calendarCurrentMonthState,
  calendarTotalMonthState,
} from "../../../recoil/calendar/calendarStateV2";
import { ArrowLeftIcon, ArrowRightIcon } from "../../../icons";

import styles from "./header.module.css";

const CalendarHeaderIndicator = ({ toolbar }) => {
  const setCalendarCurrentMonth = useSetRecoilState(calendarCurrentMonthState);
  const setCalendarTotalMonth = useSetRecoilState(calendarTotalMonthState);

  const { view, date, onNavigate } = toolbar;

  const goToNext = () => {
    const nextDate = moment(date).add(0, view).toDate();
    onNavigate("NEXT", nextDate);
    const formattedNextMonth = moment(nextDate).add(1, view).format("YYYY-MM");

    setCalendarCurrentMonth((prev) => {
      if (prev !== formattedNextMonth) return formattedNextMonth;
      return prev;
    });
    setCalendarTotalMonth((prev) => {
      if (!prev.includes(formattedNextMonth)) {
        return [...prev, formattedNextMonth];
      }
      return prev;
    });
  };

  const goToPrev = () => {
    const prevDate = moment(date).subtract(0, view).toDate();
    onNavigate("PREV", prevDate);
    const formattedPrevMonth = moment(prevDate).subtract(1, view).format("YYYY-MM");
    setCalendarCurrentMonth((prev) => {
      if (prev !== formattedPrevMonth) return formattedPrevMonth;
      return prev;
    });

    setCalendarTotalMonth((prev) => {
      if (!prev.includes(formattedPrevMonth)) {
        return [formattedPrevMonth, ...prev];
      }
      return prev;
    });
  };

  return (
    <div className="flex">
      <div
        className={styles["month-indicator"]}
        onClick={goToPrev}
        role="group"
      >
        <ArrowLeftIcon
          color={"#CACDCE"}
          _groupHover={{
            color: "white",
          }}
        />
      </div>
      <div
        className={styles["month-indicator"]}
        onClick={goToNext}
        role="group"
      >
        <ArrowRightIcon
          color={"#CACDCE"}
          _groupHover={{
            color: "white",
          }}
        />
      </div>
    </div>
  );
};

export default CalendarHeaderIndicator;
